import urabot from '../../assets/projectPreview/urabot.png';
import aigc from '../../assets/projectPreview/AIGC.png';
import urready from '../../assets/projectPreview/urready.png';
import fileshare from '../../assets/projectPreview/fileshare.PNG';
import graph from '../../assets/projectPreview/graph.png';

import fone from '../../assets/projectPreview/fone.png';
import maggle from '../../assets/projectPreview/maggle.png';
import wrapped from '../../assets/projectPreview/wrapped.png';
import mreidy from '../../assets/projectPreview/mreidy.png';

import coremera from '../../assets/projectPreview/coremera.png';
import flame from '../../assets/projectPreview/flame-gif.gif';
import underPressure from '../../assets/projectPreview/under-pressure.gif';
import turingTrouble from '../../assets/projectPreview/tt.png';
import twoTris from '../../assets/projectPreview/tris-logo.png';
import catan from '../../assets/projectPreview/catan.png';

import mmash from '../../assets/projectPreview/movie-mash.png'
import nw from '../../assets/projectPreview/nw.png'
import tir from '../../assets/projectPreview/tir.png'
import sts2 from '../../assets/projectPreview/sts2.png'
import mtg from '../../assets/projectPreview/mtg-bot.png'
import invoice from '../../assets/projectPreview/invoice.png'
import mandel from '../../assets/projectPreview/mandel.png'
import notes from '../../assets/projectPreview/notes.png'


export const applications = [
    {
        path: 'urabot',
        title: 'URaBot',
        image: urabot,
        year: 2025,
        github: 'https://github.com/notred27/URaBOT',
        live: 'https://huggingface.co/spaces/mreidy3/URaBot',
        description:
            'Chrome extension for real-time bot detection on Twitter and Bluesky. Uses a fine-tuned DeBERTa V3 model trained on 37k+ tweets, achieving 85% accuracy and a 0.79 F1 score. Supports both a remote Gradio API and a locally-hosted Docker backend for privacy.',
        highlights: [
            'Fine-tuned DeBERTa V3 on 37k+ tweets — 85% accuracy, 0.79 F1',
            'Supports local Docker deployment or remote Hugging Face Spaces API',
            'Manifest V3 Chrome extension with seamless in-page UI',
        ],
        tags: ['JavaScript', 'Python', 'Flask', 'PyTorch', 'HuggingFace', 'Docker', 'ManifestV3', 'Web Scraping', 'Deep Learning'],
    },
    {
        path: 'aigc',
        title: 'AI Image Classifier',
        image: aigc,
        year: 2023,
        github: 'https://github.com/notred27/AI-Generated-Image-Classifiers',
        live: 'https://ieeexplore.ieee.org/document/10386096',
        description:
            'Research classifiers for detecting AI-generated images using novel Color Filter Array (CFA) interpolation artifacts and fine-tuned CNNs. Achieved above-human accuracy (73–86%) on a 2,800-image dataset. Published at IEEE International Conference on Big Data 2023.',
        highlights: [
            'Published at IEEE BigData 2023',
            'Achieved 73–86% accuracy, outperforming human benchmarks',
            'Novel CFA-based feature extraction without requiring deep learning',
        ],
        tags: ['Python', 'MATLAB', 'PyTorch', 'ResNet-50', 'Deep Learning', 'Computer Vision'],
    },
    {
        path: 'mtg-bot',
        title: 'MTG Ranking Bot',
        image: mtg,
        year: 2026,
        github: 'https://github.com/notred27/MTG-Ranking-Bot',
        live: null,
        description:
            'Discord bot for tracking Commander (Magic: The Gathering) match history, player placements, and ELO-style rankings. Backed by a persistent SQLite database and containerized with Docker for easy self-hosting.',
        highlights: [
            'Tracks full Commander match history and player rankings',
            'Persistent SQLite backend with Docker deployment',
            'Discord slash command interface',
        ],
        tags: ['Python', 'Discord', 'SQLite', 'Docker'],
    },
    {
        path: 'fileshare',
        title: 'Simple Fileshare',
        image: fileshare,
        year: 2024,
        github: "https://github.com/notred27/SimpleFileshare",
        live: null,
        description:
            'Lightweight peer-to-peer file sharing tool built with Python TCP/IP sockets and a browser-based frontend. Designed for local network transfers without third-party services.',
        highlights: [
            'Raw TCP/IP socket implementation — no third-party transfer libraries',
            'Browser-based UI served from a local Python server',
            'Designed in Figma before implementation',
        ],
        tags: ['Python', 'HTML/CSS', 'TCP/IP Sockets', 'Figma'],
    },
    {
        path: 'invoice',
        title: 'Invoice Constructor',
        image: invoice,
        year: 2026,
        github: "https://github.com/notred27/Invoice-Constructor",
        live: null,
        description:
            'React + TypeScript tool for generating and exporting professional invoices. Built with Vite for fast local development, with a clean UI for adding line items, client details, and totals.',
        highlights: [
            'Generates printable/exportable invoices from a form UI',
            'TypeScript for type-safe form state management',
            'Built with Vite for fast dev and optimized builds',
        ],
        tags: ['TypeScript', 'React', 'Vite', 'HTML/CSS'],
    },
    {
        path: 'graph',
        title: 'Bond Percolation Visualizer',
        image: graph,
        year: 2025,
        github: "https://github.com/notred27/BondPercolationSimulator",
        live: "https://github.com/notred27/BondPercolationSimulator/blob/main/Math_Final_Report.pdf",
        description:
            'Interactive visualization of percolation theory using Python and Matplotlib. Simulates grid-based percolation thresholds and animates the flooding process step by step.',
        highlights: [
            'Animates union-find based percolation on an NxN grid',
            'Configurable grid size and threshold estimation',
        ],
        tags: ['Python', 'Matplotlib'],
    },
    {
        path: 'urready',
        title: 'You\'re Ready',
        image: urready,
        year: 2023,
        github: "https://github.com/notred27/YoureReady",
        live: null,
        description:
            'Desktop app that scrapes the University of Rochester course registration system and notifies users when a closed course opens up. Built with Selenium for scraping and Tkinter for the GUI.',
        highlights: [
            'Polls UR\'s course system and alerts on seat availability',
            'Selenium-based scraper with configurable poll intervals',
            'Tkinter GUI for managing watched courses',
        ],
        tags: ['Python', 'Selenium', 'Tkinter', 'Web Scraping'],
    },
    {
        path: 'mandelbrot',
        title: 'Mandelbrot Visualizer',
        image: mandel,
        year: 2022,
        github: "https://github.com/notred27/mandel",
        live: null,
        description:
            'Interactive Mandelbrot set explorer built with Java Swing. Supports panning and zooming into the fractal with real-time rendering.',
        highlights: [
            'Real-time Mandelbrot rendering with configurable iteration depth',
            'Pan and zoom navigation via slider inputs',
        ],
        tags: ['Java', 'Swing'],
    },
    {
        path: 'notes-app',
        title: 'Notes App',
        image: notes,
        year: 2022,
        github: "https://github.com/notred27/NotesApp",
        live: null,
        description:
            'Simple desktop notes application built with Java Swing. Supports creating, editing, saving, and deleting notes with persistent local storage.',
        highlights: [
            'CRUD note management with local file persistence',
            'Create connections between nodes, store information, and view node relations',
        ],
        tags: ['Java', 'Swing'],
    },
];


// ─── WEBSITES ────────────────────────────────────────────────────────────────

export const websites = [
    {
        path: 'rifting-wrapped',
        title: 'Rifting Wrapped',
        image: wrapped,
        year: 2025,
        github: 'https://github.com/notred27/RiftingWrapped',
        live: 'https://www.riftingwrapped.com',
        description:
            'Full-stack League of Legends analytics app with 200+ active users. Visualizes yearly match history with champion distributions, kill heatmaps, and performance breakdowns. Match data is kept fresh via GitHub Actions cron jobs. Riot-approved.',
        highlights: [
            '200+ active users — Riot Games approved',
            'Automated match scraping pipeline via GitHub Actions cron jobs',
            'Interactive heatmaps, champion stats, and performance breakdowns',
        ],
        tags: ['React', 'Flask', 'MongoDB', 'Riot API', 'AWS Amplify', 'GitHub Actions', 'JavaScript', 'HTML/CSS'],
    },
	  {
        path: 'movie-mash',
        title: 'Movie Mash',
        image: mmash,
        year: 2025,
        github: "https://github.com/notred27/MovieMash",
        live: null,
        description:
            'Movie browsing and rating web app built with PHP and MySQL. Users can search for films, view details, and save ratings to a persistent database.',
        highlights: [
            'Server-side rendering with PHP and a MySQL relational database',
            'Designed in Figma with a cinematic visual style',
        ],
        tags: ['PHP', 'MySQL', 'JavaScript', 'HTML/CSS', 'Figma', 'Docker'],
    },
    {
        path: 'fone',
        title: 'Fone',
        image: fone,
        year: 2023,
        github: "https://github.com/notred27/Fone",
        live: "https://main.dtrjhr0w2mwu1.amplifyapp.com/",
        description:
            'Social music sharing app built with React and Firebase. Users can sign in with Google, post what they\'re listening to, and browse friends\' recent tracks in a real-time feed.',
        highlights: [
            'Real-time feed with Google Auth and Firebase backend',
            'Designed end-to-end in Figma before implementation',
        ],
        tags: ['React', 'Firebase', 'Google Auth', 'JavaScript', 'HTML/CSS', 'Figma'],
    },
    {
        path: 'maggle',
        title: 'Maggle',
        image: maggle,
        year: 2023,
        github: "https://github.com/notred27/Maggle",
        live: "https://aws-deployment.dhqsr5m8z3m6j.amplifyapp.com/login",
        description:
            'A Heardle-like game based on your Spotify playlists! Users guess songs from their Spotify playlists by listening to progressively longer segments of a track.  ',
        highlights: [
            'OAuth Spotify integration for personalized experiences',
            'Designed in Figma with a music-forward visual style',
        ],
        tags: ['React', 'Spotify API', 'JavaScript', 'HTML/CSS', 'Figma'],
    },

    {
        path: 'mreidy',
        title: 'mreidy.com',
        image: mreidy,
        year: 2024,
        github: null,
        live: 'https://www.mreidy.com',
        description:
            'This portfolio site! Built with React and deployed on AWS Amplify. Designed in Figma with a focus on clean typography, dark-mode aesthetics, and smooth navigation.',
        highlights: [
            'Designed in Figma before implementation',
            'Deployed on AWS Amplify with CI/CD from GitHub',
            'Custom lazy-loading image system and responsive layout',
        ],
        tags: ['React', 'AWS Amplify', 'JavaScript', 'HTML/CSS', 'Figma'],
    },
];


// ─── GAMES ───────────────────────────────────────────────────────────────────

export const games = [
  
    
    {
        path: 'trauma-informed-responses',
        title: 'Trauma Informed Responses',
        image: tir,
        year: 2025,
        github: null,
        live: null,
        description:
            'Unreal Engine 5 training simulation in development for social work education, targeting an Epic MegaGrant proposal. Features scenario-based learning with branching decision trees for experiential training.',
        highlights: [
            'Developed by Waffle Works Games as part of an Epic MegaGrant proposal',
            'Scenario-based branching simulation for social work training',
            'Built with Unreal Engine 5 with custom 3D environments',
        ],
        tags: ['Unreal Engine 5', 'C#', 'Blender'],
    },
{
        path: 'neighborhood-watch',
        title: 'Neighborhood Watch',
        image: nw,
        year: 2025,
        github: null,
        live: null,
        description:
            'A Godot-based narrative game developed at Waffle Works Games. Features dialogue-driven gameplay with a branching story system and custom 2D assets.',
        highlights: [
            'Dialogue engine with branching narrative logic',
            'Custom 3D assets modeled and rigged in Blender',
        ],
        tags: ['Godot', 'C#', 'Blender', 'GDScript'],
    },
	  {
        path: 'sts2-mod',
        title: 'Slay The Spire 2 Mod',
        image: sts2,
        year: 2025,
        github: "https://github.com/notred27/sts2_damage_tracker",
        live: null,
        description:
            'A mod for Slay The Spire 2 built with Godot and Harmony patching. Adds a live tracker to view how much damage you and your teammates do.',
        highlights: [
            'Runtime patching via Harmony (.NET) to modify base game behavior',
            'Compatible with multiplayer (as of v0.101.0-beta).',
        ],
        tags: ['Godot', 'C#', 'Harmony', '.NET'],
    },
    {
        path: 'coremera',
        title: 'Coremera',
        image: coremera,
        year: 2024,
        github: null,
        live: null,
        description:
            'A 3D auto-battler game built in Godot with custom C# gameplay systems and original 3D assets modeled in Blender.',
        highlights: [
            'Custom gameplay systems built in C# with Godot',
            'Original 3D models and animations from Blender',
        ],
        tags: ['Godot', 'C#', 'Blender', "GDScript"],
    },
    {
        path: 'flames-legacy',
        title: "Flame's Legacy",
        image: flame,
        year: 2025,
        github: "https://github.com/YAGOTAGO/Flames-Legacy",
        live: "https://tdavies.itch.io/flames-legacy",
        description:
            "A 3D combat game built in Godot for the Excalibur Game Jam 2025. Won 1st place overall. Features a custom GDScript state machine for enemy AI and original Blender assets.",
        highlights: [
            '🥇 1st Place Overall — Excalibur Game Jam 2025',
            'Custom enemy AI via GDScript state machine',
            'Original art and assets created in Blender',
        ],
        tags: ['Godot', 'GDScript', 'Blender'],
    },
    {
        path: 'under-pressure',
        title: 'Under Pressure',
        image: underPressure,
        year: 2024,
        github: 'https://github.com/YAGOTAGO/UnderPressure',
        live: "https://tdavies.itch.io/under-pressure",
        description:
            '3D task-management game built in Godot for DandyHacks 2024. Won 1st place in the Entertainment Track and Best Overall. Players navigate pressure-based mechanics across a series of increasingly complex levels.',
        highlights: [
            '🥇 1st Place Overall & Entertainment Track — DandyHacks 2024',
            'Pressure-based physics puzzle mechanics in Godot',
            'Custom 3D levels and assets built in Blender',
        ],
        tags: ['Godot', 'GDScript', 'Blender'],
    },
    {
        path: 'turing-trouble',
        title: 'Turing Trouble',
        image: turingTrouble,
        year: 2023,
        github: "https://github.com/notred27/Turing-Trouble",
        live: "https://tdavies.itch.io/turing-trouble",
        description:
            'A puzzle game about Turing machines and simulated logic, built in Unity for DandyHacks 2023. Won 1st place in the Entertainment Track. Players edit transition tables to solve computational puzzles.',
        highlights: [
            '🥇 1st Place — Entertainment Track, DandyHacks 2023',
            'Turing machine puzzle mechanics',
            'Built in Unity with C# in under 24 hours',
        ],
        tags: ['Unity', 'C#'],
    },
    {
        path: 'two-tris',
        title: '2-Tris',
        image: twoTris,
        year: 2022,
        github: "https://github.com/notred27/2-TRIS",
        live: null,
        description:
            'A cooperative two-player Tetris variant built with PyGame for DandyHacks 2022. Won 1st place in the Entertainment Track and Best UI/UX. Players race to clear lines while working together with a teammate.',
        highlights: [
            '🥇 1st Place — Entertainment Track & Best UI/UX, DandyHacks 2022',
            'Two-player cooperative Tetris variant with split-control mechanics',
            'Built with PyGame in under 24 hours',
        ],
        tags: ['Python', 'PyGame'],
    },
    {
        path: 'catan',
        title: 'Catan',
        image: catan,
        year: 2023,
        github: "https://github.com/notred27/Catan",
        live: null,
        description:
            'Networked multiplayer implementation of Settlers of Catan built with PyGame and TCP/IP sockets. Supports up to 4 players over a local network with a full game rules engine and custom UI designed in Figma.',
        highlights: [
            'Full Catan rules engine with resource trading and victory points',
            'LAN multiplayer via raw TCP/IP sockets',
            'Custom UI and board design in Figma',
        ],
        tags: ['Python', 'PyGame', 'TCP/IP Sockets', 'Figma'],
    },
];